(function () {
  var root = document.querySelector('[data-tradein-root]');
  if (!root) return;

  var proxyBase = root.getAttribute('data-proxy-base') || '/apps/tradein';

  /* ---------- Page intro: dynamic bonus amount (never hardcoded) ---------- */
  var bonusEls = Array.prototype.slice.call(root.querySelectorAll('[data-ti-bonus-amount]'));
  fetch(proxyBase + '/config')
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (body) {
      if (!body || body.tradeInBonus == null) return;
      bonusEls.forEach(function (el) {
        el.textContent = Math.round(body.tradeInBonus).toLocaleString('de-DE');
      });
      root.setAttribute('data-ti-bonus-value', String(Math.round(body.tradeInBonus)));
    })
    .catch(function () {});

  /* ---------- Step form (Fahrrad / Antrieb / Zustand) ---------- */
  var form = root.querySelector('[data-ti-form]');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ti-step]'));
  var progressSteps = Array.prototype.slice.call(root.querySelectorAll('[data-ti-progress] [data-step]'));
  var analysisEl = root.querySelector('[data-ti-analysis]');
  var analysisSteps = Array.prototype.slice.call(root.querySelectorAll('[data-ti-astep]'));
  var resultEl = root.querySelector('[data-ti-result]');
  var resultPriceEl = root.querySelector('[data-ti-result-price]');
  var followupEl = root.querySelector('[data-ti-followup]');
  var unavailableEl = root.querySelector('[data-ti-unavailable]');

  var currentStep = 1;
  var currentRequestId = null;
  var currentTradeInValue = null;

  function showStep(n) {
    currentStep = n;
    steps.forEach(function (el) {
      el.classList.toggle('is-active', Number(el.getAttribute('data-ti-step')) === n);
    });
    progressSteps.forEach(function (el) {
      var stepNum = Number(el.getAttribute('data-step'));
      el.classList.toggle('is-active', stepNum === n);
      el.classList.toggle('is-done', stepNum < n);
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(stepEl) {
    var inputs = stepEl.querySelectorAll('input, select, textarea');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].reportValidity()) return false;
    }
    return true;
  }

  /* ---------- Condition cards (Schritt 3) ---------- */
  var conditionCards = Array.prototype.slice.call(root.querySelectorAll('[data-ti-condition-card]'));
  var conditionInput = root.querySelector('[data-ti-condition-input]');
  conditionCards.forEach(function (card) {
    card.addEventListener('click', function () {
      conditionCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      conditionInput.value = card.getAttribute('data-value');
    });
  });

  root.addEventListener('click', function (e) {
    if (e.target.matches('[data-ti-next]')) {
      var activeStep = steps[currentStep - 1];
      if (!validateStep(activeStep)) return;
      showStep(Math.min(currentStep + 1, steps.length));
    }
    if (e.target.matches('[data-ti-prev]')) {
      showStep(Math.max(currentStep - 1, 1));
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!conditionInput.value) {
      var conditionGrid = root.querySelector('.smb-ti__condition-grid');
      if (conditionGrid) {
        conditionGrid.classList.add('is-invalid');
        conditionGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { conditionGrid.classList.remove('is-invalid'); }, 1600);
      }
      return;
    }
    var data = collectFormData();
    startAnalysis(data);
  });

  function collectFormData() {
    var fd = new FormData(form);
    var payload = {};
    fd.forEach(function (value, key) {
      if (value !== '') payload[key] = value;
    });

    ['modelYear', 'uvp', 'batteryCapacityWh', 'mileageKm'].forEach(function (key) {
      if (payload[key] !== undefined) payload[key] = Number(payload[key]);
    });

    [
      'accidentDamage',
      'motorError',
      'batteryError',
      'displayWorks',
      'chargerIncluded',
      'batteryKeyIncluded',
      'originalInvoice',
    ].forEach(function (key) {
      payload[key] = payload[key] === 'true';
    });

    return payload;
  }

  function startAnalysis(payload) {
    form.hidden = true;
    root.querySelector('.smb-ti__progress').hidden = false;
    analysisEl.hidden = false;
    showStep(4);
    animateAnalysisSteps();

    fetch(proxyBase + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.status === 404) throw new Error('proxy_unavailable');
        if (!res.ok) return res.json().then(function (body) { throw new Error(body.error || 'submit_failed'); });
        return res.json();
      })
      .then(function (body) {
        currentRequestId = body.requestId;
        pollStatus(body.requestId);
      })
      .catch(function () {
        showUnavailable();
      });
  }

  var analysisStepTimer = null;
  function animateAnalysisSteps() {
    var i = 0;
    function next() {
      analysisSteps.forEach(function (el, idx) {
        el.classList.toggle('is-done', idx < i);
        el.classList.toggle('is-active', idx === i);
      });
      i++;
      if (i <= analysisSteps.length) {
        analysisStepTimer = setTimeout(next, 3500);
      }
    }
    next();
  }

  var pollTimer = null;
  var pollStart = null;
  var MAX_POLL_MS = 60000;

  function pollStatus(requestId) {
    pollStart = Date.now();
    poll();

    function poll() {
      if (Date.now() - pollStart > MAX_POLL_MS) {
        showManualReview('Die Bewertung dauert länger als erwartet — wir melden uns persönlich bei dir.');
        return;
      }

      fetch(proxyBase + '/status/' + encodeURIComponent(requestId))
        .then(function (res) {
          if (res.status === 404) throw new Error('proxy_unavailable');
          return res.json();
        })
        .then(function (body) {
          if (body.status === 'processing') {
            pollTimer = setTimeout(poll, 2500);
            return;
          }
          if (body.status === 'manual_review' || body.status === 'range') {
            showManualReview(body.message, body.priceRangeLow, body.priceRangeHigh);
            return;
          }
          if (body.status === 'done') {
            showResult(body);
            return;
          }
          throw new Error('unexpected_status');
        })
        .catch(function () {
          showUnavailable();
        });
    }
  }

  function showResult(body) {
    clearTimeout(analysisStepTimer);
    analysisEl.hidden = true;
    resultEl.hidden = false;
    currentTradeInValue = body.tradeIn;

    var direct = body.directSale;
    var tradeIn = body.tradeIn;
    var bonus = body.tradeInBonus;

    resultPriceEl.innerHTML =
      '<h2 class="smb-ti__result-title">Dein vorläufiges Angebot</h2>' +
      '<div class="smb-ti__result-row">' +
      '<div class="smb-ti__result-option">' +
      '<p class="smb-ti__result-label">Direktverkauf an SMBIKES</p>' +
      '<p class="smb-ti__result-value">' + formatEuro(direct) + '</p>' +
      '</div>' +
      '<div class="smb-ti__result-option smb-ti__result-option--accent">' +
      '<span class="smb-ti__result-badge">Beliebteste Wahl</span>' +
      '<p class="smb-ti__result-label">Beim Kauf eines neuen Fahrrads</p>' +
      '<p class="smb-ti__result-value">' + formatEuro(tradeIn) + '</p>' +
      '<p class="smb-ti__result-sub">Beim Kauf eines neuen Bikes erhältst du zusätzlich ' + formatEuro(bonus) + ' Inzahlungnahme-Bonus.</p>' +
      '</div>' +
      '</div>' +
      '<a class="smb-ti__btn smb-ti__btn--primary smb-ti__btn--block" href="/pages/contact">Angebot sichern</a>' +
      '<p class="smb-ti__disclaimer">Unverbindliche Online-Bewertung. Der endgültige Ankaufspreis wird nach technischer Prüfung des Fahrrads durch SMBIKES bestätigt.</p>';

    renderFollowup();
  }

  function showManualReview(message, low, high) {
    clearTimeout(analysisStepTimer);
    analysisEl.hidden = true;
    resultEl.hidden = false;

    var rangeHtml = '';
    if (low != null && high != null) {
      rangeHtml =
        '<p class="smb-ti__result-range">Voraussichtlicher Ankaufspreis: ' +
        formatEuro(low) + '–' + formatEuro(high) + '</p>';
    } else {
      rangeHtml = '<p class="smb-ti__result-range smb-ti__result-range--text">Für dieses E-Bike möchten wir den Preis persönlich prüfen.</p>';
    }

    resultPriceEl.innerHTML =
      '<h2 class="smb-ti__result-title">Vielen Dank für deine Anfrage!</h2>' +
      rangeHtml +
      '<p class="smb-ti__result-sub">' + (message || 'Wir prüfen dein Fahrrad persönlich und melden uns mit einem individuellen Angebot.') + '</p>' +
      '<a class="smb-ti__btn smb-ti__btn--primary smb-ti__btn--block" href="/pages/contact">Kostenlose Bewertung anfragen</a>';

    renderFollowup();
  }

  function showUnavailable() {
    clearTimeout(analysisStepTimer);
    analysisEl.hidden = true;
    resultEl.hidden = true;
    form.hidden = true;
    unavailableEl.hidden = false;
  }

  function formatEuro(value) {
    if (value == null) return '–';
    return Math.round(value).toLocaleString('de-DE') + ' €';
  }

  /* ---------- "Welches neue Fahrrad interessiert dich?" + Fotos ---------- */
  function renderFollowup() {
    if (!followupEl || !currentRequestId) return;
    followupEl.hidden = false;
    followupEl.innerHTML = buildInterestHtml() + buildPhotoHtml();
    bindInterestEvents();
    bindPhotoEvents();
  }

  var CATEGORY_LABELS = {
    UNSICHER: 'Noch unsicher',
    E_TREKKING: 'E-Trekking',
    E_SUV: 'E-SUV',
    E_MTB: 'E-MTB',
    E_FULLY: 'E-Fully',
    E_CITY: 'E-City',
    TIEFEINSTEIGER: 'Tiefeinsteiger',
    GRAVEL_EBIKE: 'Gravel / Rennrad',
  };

  function buildInterestHtml() {
    var buttons = Object.keys(CATEGORY_LABELS)
      .map(function (key) {
        return '<button type="button" class="smb-ti__chip" data-ti-interest-category="' + key + '">' + CATEGORY_LABELS[key] + '</button>';
      })
      .join('');

    return (
      '<div class="smb-ti__followup-block" data-ti-interest-block>' +
      '<h3 class="smb-ti__followup-title">Welches neue Fahrrad interessiert dich?</h3>' +
      '<p class="smb-ti__followup-hint">Optional — hilft uns, dir direkt passende Angebote zu zeigen.</p>' +
      '<div class="smb-ti__chip-row">' + buttons +
      '<button type="button" class="smb-ti__chip smb-ti__chip--outline" data-ti-interest-search-toggle>Konkretes Fahrrad auswählen</button>' +
      '</div>' +
      '<div class="smb-ti__interest-search" data-ti-interest-search hidden>' +
      '<input type="search" class="smb-ti__interest-search-input" data-ti-interest-search-input placeholder="z.B. Merida eSPRESSO">' +
      '<div class="smb-ti__interest-results" data-ti-interest-results></div>' +
      '</div>' +
      '<div class="smb-ti__interest-confirmed" data-ti-interest-confirmed hidden></div>' +
      '</div>'
    );
  }

  function bindInterestEvents() {
    var block = followupEl.querySelector('[data-ti-interest-block]');
    if (!block) return;

    block.querySelectorAll('[data-ti-interest-category]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        block.querySelectorAll('[data-ti-interest-category]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        sendInterest({ interestedCategory: btn.getAttribute('data-ti-interest-category') });
        showInterestConfirmed('Danke! Wir melden uns mit passenden ' + btn.textContent + '-Angeboten.');
      });
    });

    var searchToggle = block.querySelector('[data-ti-interest-search-toggle]');
    var searchWrap = block.querySelector('[data-ti-interest-search]');
    var searchInput = block.querySelector('[data-ti-interest-search-input]');
    var resultsEl = block.querySelector('[data-ti-interest-results]');

    searchToggle.addEventListener('click', function () {
      searchToggle.classList.add('is-selected');
      searchWrap.hidden = false;
      searchInput.focus();
    });

    var searchTimer = null;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        resultsEl.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch(proxyBase + '/search-products?q=' + encodeURIComponent(q))
          .then(function (res) { return res.ok ? res.json() : { products: [] }; })
          .then(function (body) {
            renderProductResults(resultsEl, body.products || []);
          })
          .catch(function () {
            resultsEl.innerHTML = '';
          });
      }, 350);
    });
  }

  function renderProductResults(resultsEl, products) {
    if (products.length === 0) {
      resultsEl.innerHTML = '<p class="smb-ti__interest-empty">Keine Treffer.</p>';
      return;
    }
    resultsEl.innerHTML = products
      .map(function (p) {
        return (
          '<button type="button" class="smb-ti__interest-product" ' +
          'data-id="' + escapeAttr(p.id) + '" data-title="' + escapeAttr(p.title) + '" data-price="' + p.price + '">' +
          (p.image ? '<img src="' + escapeAttr(p.image) + '" alt="">' : '<span class="smb-ti__interest-product-noimg"></span>') +
          '<span class="smb-ti__interest-product-info">' +
          '<span class="smb-ti__interest-product-title">' + escapeHtml(p.title) + '</span>' +
          '<span class="smb-ti__interest-product-price">' + formatEuro(p.price) + '</span>' +
          '</span>' +
          '</button>'
        );
      })
      .join('');

    resultsEl.querySelectorAll('.smb-ti__interest-product').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-id');
        var title = btn.getAttribute('data-title');
        var price = Number(btn.getAttribute('data-price'));
        sendInterest({ interestedProductId: id, interestedProductTitle: title, interestedProductPrice: price });
        showInterestConfirmed(null, title, price);
      });
    });
  }

  function showInterestConfirmed(genericMessage, productTitle, productPrice) {
    var confirmedEl = followupEl.querySelector('[data-ti-interest-confirmed]');
    if (!confirmedEl) return;
    confirmedEl.hidden = false;

    if (productTitle != null && currentTradeInValue != null) {
      var restbetrag = productPrice - currentTradeInValue;
      confirmedEl.innerHTML =
        '<div class="smb-ti__restbetrag">' +
        '<div class="smb-ti__restbetrag-row"><span>Neues Fahrrad</span><span>' + formatEuro(productPrice) + '</span></div>' +
        '<div class="smb-ti__restbetrag-row"><span>Deine Inzahlungnahme</span><span>−' + formatEuro(currentTradeInValue) + '</span></div>' +
        '<div class="smb-ti__restbetrag-row smb-ti__restbetrag-row--total"><span>Voraussichtlicher Restbetrag</span><span>' + formatEuro(Math.max(restbetrag, 0)) + '</span></div>' +
        '<p class="smb-ti__restbetrag-note">Unverbindlicher Richtwert, kein verbindliches Kaufangebot.</p>' +
        '</div>';
    } else {
      confirmedEl.innerHTML = '<p class="smb-ti__interest-thanks">' + (genericMessage || 'Danke für deine Angabe!') + '</p>';
    }
  }

  function sendInterest(payload) {
    if (!currentRequestId) return;
    fetch(proxyBase + '/interest/' + encodeURIComponent(currentRequestId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(function () {});
  }

  /* ---------- Photo upload (second stage, optional) ---------- */
  var PHOTO_SLOTS = [
    { key: 'DRIVE_SIDE', label: 'Komplette Antriebsseite' },
    { key: 'OTHER_SIDE', label: 'Komplette Gegenseite' },
    { key: 'MOTOR', label: 'Motor' },
    { key: 'DISPLAY_MILEAGE', label: 'Display mit Kilometerstand' },
    { key: 'DAMAGE', label: 'Wichtige Gebrauchsspuren / Schäden' },
  ];

  function buildPhotoHtml() {
    var slots = PHOTO_SLOTS.map(function (slot) {
      return (
        '<label class="smb-ti__photo-slot" data-ti-photo-slot="' + slot.key + '">' +
        '<input type="file" accept="image/*" hidden data-ti-photo-input="' + slot.key + '">' +
        '<span class="smb-ti__photo-slot-icon" data-ti-photo-icon>' + cameraIconSvg() + '</span>' +
        '<span class="smb-ti__photo-slot-label">' + slot.label + '</span>' +
        '</label>'
      );
    }).join('');

    return (
      '<div class="smb-ti__followup-block smb-ti__photo-block">' +
      '<h3 class="smb-ti__followup-title">Gefällt dir unser Angebot?</h3>' +
      '<p class="smb-ti__followup-hint">Lade jetzt Fotos hoch, damit wir dein Angebot bestätigen können — optional, du kannst das auch später per E-Mail nachreichen.</p>' +
      '<div class="smb-ti__photo-grid">' + slots + '</div>' +
      '</div>'
    );
  }

  function cameraIconSvg() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2F7D32" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';
  }

  function checkIconSvg() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2F7D32" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function bindPhotoEvents() {
    followupEl.querySelectorAll('[data-ti-photo-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.files || !input.files[0] || !currentRequestId) return;
        var slotEl = input.closest('[data-ti-photo-slot]');
        var slotKey = input.getAttribute('data-ti-photo-input');
        slotEl.classList.add('is-uploading');

        var body = new FormData();
        body.append('slot', slotKey);
        body.append('file', input.files[0]);

        fetch(proxyBase + '/photos/' + encodeURIComponent(currentRequestId), {
          method: 'POST',
          body: body,
        })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            slotEl.classList.remove('is-uploading');
            if (result.ok) {
              slotEl.classList.add('is-done');
              slotEl.querySelector('[data-ti-photo-icon]').innerHTML = checkIconSvg();
            } else {
              slotEl.classList.add('is-error');
            }
          })
          .catch(function () {
            slotEl.classList.remove('is-uploading');
            slotEl.classList.add('is-error');
          });
      });
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }
})();
